export const ADYEN_CAPITAL_SUPPORTED_COUNTRIES = ['SW', 'GB', 'US', 'PR', 'AU'];
